import { Observable } from 'rxjs';
import { DefaultCompany, DefaultCompanyRequest } from '@src/core/domain/company/defaultCompany.model';

export abstract class DefaultCompanyRepository {
  abstract setDefaultCompany(obj: DefaultCompanyRequest): Observable<DefaultCompany>;
}